@if(visible) {
<app-stepper [config]="aiAssistantStepperConfig" [visible]="visible"
    (visibleChange)="visible = $event; visibleChange.emit($event)" (close)="onStepperClose()"
    (finish)="onStepperFinish()" [finishButtonLoading]="aiAssistant.loading">
    <div *stepperStep="step1Config" class="flex-1 flex flex-col min-h-0 overflow-hidden">
        <ng-container *ngTemplateOutlet="libraryTemplate"></ng-container>
    </div>
    <div *stepperStep="step2Config">
        <ng-container *ngTemplateOutlet="referenceDocumentsTemplate"></ng-container>
    </div>
    <div *stepperStep="step3Config" class="flex-1 flex flex-col min-h-0">
        <app-tabs-panels class="tabs-header-only" [tabs]="customisationTabs" [activeTabValue]="activeCustomisationTab"
            (tabChanged)="onCustomisationTabChange($event)" customClass="ai-assistant-dialog"
            [tabPanelsClass]="'flex-1 min-h-0 overflow-hidden p-0'">
        </app-tabs-panels>
        <div class="flex-1 min-h-0 flex flex-col overflow-hidden">
            @if(activeCustomisationTab === 'customisations') {
            <div class="flex flex-col gap-4 py-4 flex-1 min-h-0 overflow-y-auto">
                <div class="flex flex-col gap-2">
                    <label class="text-sm font-semibold">Add custom prompt instructions</label>
                    <app-input [(ngModel)]="customisationPrompt" type="textarea" [rows]="5"
                        class="w-full rounded-base max-h-[10rem] min-h-[6rem] xl:min-h-[10rem] xl:max-h-[12rem] overflow-y-auto"
                        placeholder="Describe what you want to generate">
                    </app-input>
                    <div
                        class="flex flex-row w-full my-2 gap-2 overflow-x-auto whitespace-nowrap pb-1.5 menu-items-scrollable ">
                        @for(question of promptQuestions; track $index) {
                        <div class="cursor-pointer theme-border rounded-base text-xs text-center font-sans font-medium px-2 py-1"
                            [class.pointer-events-none]="loading" (click)="sendPrompt(question.prompt)">
                            {{ question.label }}
                        </div>
                        }
                    </div>
                    <div class="flex items-center gap-2">
                        <img [src]="'images/icons/star.svg' | assetUrl" pTooltip="{{'AI Generated' | titlecase}}"
                            tooltipPosition="top" class=" h-4 w-4 italic" alt="Star icon">
                        <span class="flex items-center gap-3 text-sm text-gray-500 italic theme-text">
                            Powered by InnDoc AI
                        </span>
                    </div>
                </div>
                <div class="flex flex-col gap-2 max-w-[50%]">
                    <label class="text-sm font-semibold">Tone</label>
                    <app-menu #toneMenu [items]="toneMenuItems" [selectedValues]="selectedToneMenuValues"
                        [visible]="toneMenuVisible" position="left-bottom" appendTo="body" width="100%"
                        (visibleChange)="toneMenuVisible = $event" (itemSelected)="onToneSelected($event)">
                        <app-button variant="outlined" severity="contrast"
                            class="w-full flex items-center justify-between text-left text-sm"
                            (clicked)="toneMenu.toggle($event)">
                            <span class="flex items-center gap-2 min-w-0">
                                @if(selectedToneItem; as toneItem) {
                                @if(toneItem.icon) {
                                <app-icon [type]="toneItem.icon" [source]="toneItem.iconSource ?? 'svg'" [size]="'sm'"
                                    class="flex-shrink-0"></app-icon>
                                }
                                }
                                <span class="truncate">{{ selectedToneLabel }}</span>
                            </span>
                            <app-icon type="pi pi-chevron-down" source="primeng" size="sm"
                                class="text-gray-500 text-xs flex-shrink-0"></app-icon>
                        </app-button>
                    </app-menu>
                </div>
                <div class="flex flex-col gap-2 max-w-[50%]">
                    <label class="text-sm font-semibold">Project</label>
                    <app-select #projectSelect [(value)]="selectedProjectId" [options]="projectOptions"
                        [config]="{ placeholder: 'Select project', searchable: true, clearable: true, loading: projectsLoading, appendTo: 'body', backendSearch: true, infiniteScroll: true }"
                        (onSearch)="onProjectSearch($event)" (onLoadMore)="onProjectLoadMore()"
                        (onClear)="onProjectCleared()">
                    </app-select>
                </div>
                <div class="flex flex-col gap-2 max-w-[50%]">
                    <label class="text-sm font-semibold">Due Date</label>
                    <app-datepicker class="cursor-pointer" [(value)]="dueDate" [config]="dueDateConfig">
                    </app-datepicker>
                </div>
            </div>
            }
            @if(activeCustomisationTab === 'milestones') {
            <div class="py-4 flex-1 min-h-0 overflow-hidden">
                <app-milestones [milestones]="milestones" [showHeader]="false" [showActions]="false"
                    [permissions]="milestonePermissions" class="h-full w-full"
                    [(editableMilestones)]="editableMilestones" [(deletedMilestoneIds)]="deletedMilestoneIds"
                    (milestonesChange)="onMilestonesChange($event)">
                </app-milestones>
            </div>
            }
        </div>
    </div>
    <div *stepperStep="step4Config">
        <app-share-to-users [shareDetails]="shareDetails" [isDocumentForm]="true" [projectId]="selectedProjectId"
            (removeUserFromShare)="onRemoveUserFromShare($event)" (updateSharedUser)="onShareUpdateUser($event)"
            (changeAnyoneAccess)="shareDetails.anyone = $event">
        </app-share-to-users>
    </div>
</app-stepper>
}

<ng-template #libraryTemplate>
    <div class="flex flex-col h-full rounded-xl bg-white overflow-hidden">

        <app-tabs-panels class="tabs-header-only flex-shrink-0" [tabs]="libraryTabs" [activeTabValue]="activeLibraryTab"
            (tabChanged)="onLibraryTabChange($event)" customClass="ai-assistant-dialog"
            [tabPanelsClass]="'min-h-0 overflow-hidden p-0'">
        </app-tabs-panels>

        <div class="flex flex-col flex-1 min-h-0 pt-3 gap-3">

            <div class="flex items-center justify-between gap-3 flex-wrap flex-shrink-0">
                <div class="w-full sm:w-64 md:w-80">
                    <app-search-bar [(ngModel)]="librarySearchValue" (searchChange)="onLibrarySearchChange()"
                        placeholder="Search with {{ activeLibraryTab === 'template' ? 'template name / ID' : 'clause name' }}"
                        width="100%">
                    </app-search-bar>
                </div>

                @if(activeLibraryTab === 'template' && isAdmin) {
                <app-button variant="outlined" severity="contrast" icon="pi pi-plus" label="New template"
                    (clicked)="onNewTemplate()">
                </app-button>
                }

                @if(activeLibraryTab === 'clause') {
                <div class="flex items-center gap-2 flex-shrink-0">
                    <div class="w-full sm:w-48 md:w-56">
                        <app-select [(value)]="selectedLibraryBundleId" [options]="clauseBundleOptions"
                            [config]="libraryBundleSelectConfig" (onChange)="onLibraryBundleChange($event.value)">
                        </app-select>
                    </div>

                    @if(isAdmin) {
                    <app-button variant="outlined" severity="contrast" icon="pi pi-plus" label="New clause"
                        (clicked)="onNewClause()">
                    </app-button>
                    }
                </div>
                }
            </div>

            @if(activeLibraryTab === 'clause' && displayLibraryItems.length > 0) {
            <div class="flex items-center gap-2 flex-shrink-0">
                <app-checkbox [value]="allClausesSelected"
                    (onChange)="onToggleSelectAllClauses($event.checked === true)" [config]="{
                            binary: true,
                            label: 'Select All',
                            inputId: 'select-all-clauses'
                        }">
                </app-checkbox>

                @if(displayLibraryItems.length > 0) {
                <span class="text-sm text-gray-500">
                    ({{ displayLibraryItems.length }})
                </span>
                }
            </div>
            }

            @if(libraryLoading) {
            <div class="flex flex-1 items-center justify-center">
                <i class="pi pi-spin pi-spinner text-2xl text-arena-orange"></i>
            </div>
            }

            @else {
            <div class="flex-1 overflow-y-auto min-h-0">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">

                    @for (item of displayLibraryItems; track item._id) {
                    <div (click)="selectLibraryItem(item._id)"
                        class="flex items-center gap-3 p-3 rounded-xl border border-gray-200 bg-white shadow-sm cursor-pointer hover:shadow-md transition min-h-[5rem]"
                        [ngClass]="{
                                    'border-arena-orange-500 bg-arena-orange-50':
                                    activeLibraryTab === 'template'
                                        ? selectedLibraryItemId === item._id
                                        : selectedLibraryClauseIds.includes(item._id)
                                }">

                        <div class="flex-shrink-0"
                            (click)="activeLibraryTab === 'template' && onTemplateRadioClick($event, item._id)">
                            @if(activeLibraryTab === 'template') {
                            <p-radioButton name="libraryItem" [value]="item._id" [(ngModel)]="selectedLibraryItemId"
                                [inputId]="'lib-' + item._id">
                            </p-radioButton>
                            } @else {
                            <app-checkbox [(value)]="selectedLibraryClauseIds" [checkboxValue]="item._id">
                            </app-checkbox>
                            }
                        </div>

                        <div class="flex flex-col flex-1 min-w-0">
                            @if(activeLibraryTab === 'template') {
                            <span class="text-sm text-gray-500">
                                ID - {{ item.templateId || item._id.slice(-4) }}
                            </span>
                            }
                            <span class="text-sm font-semibold text-gray-900 line-clamp-2" [pTooltip]="item.name">
                                {{ item.name || 'Untitled' }}
                            </span>
                        </div>

                        <div class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100"
                            (click)="$event.stopPropagation(); onViewLibraryItem(item)" pTooltip="View">
                            <app-icon type="pi pi-eye" source="primeng" size="lg"></app-icon>
                        </div>
                    </div>
                    }

                </div>

                @if(displayLibraryItems.length === 0 && !libraryLoading) {
                <div class="flex flex-1 flex-col items-center justify-center gap-4">
                    <img class="w-1/2 h-1/2 object-contain" src="images/templates_not_found.png">
                    <p class="text-sm text-gray-500">
                        {{ activeLibraryTab === 'template' ? 'No templates found' : 'No clauses found' }}
                    </p>
                </div>
                }
            </div>
            }

        </div>

        <!-- FIXED: Paginator — always visible at the bottom -->
        @if(libraryTotalRecords > 0 && !libraryLoading) {
        <div class="flex-shrink-0">
            <p-paginator class="w-full" [first]="libraryFirst" [rows]="libraryRows" [totalRecords]="libraryTotalRecords"
                [rowsPerPageOptions]="libraryRowsPerPageOptions" (onPageChange)="onLibraryPageChange($event)"
                class="mt-auto pt-3 flex justify-center items-center" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
            </p-paginator>
        </div>
        }
    </div>
</ng-template>


<ng-template #referenceDocumentsTemplate>
    <div class="flex flex-row justify-between items-center mb-3">
        <span class="text-md font-semibold">Documents</span>
        <app-button variant="outlined" severity="contrast" icon="pi pi-upload" iconPosition="left" label="Upload"
            (clicked)="openUploadDocumentsDialog()">
        </app-button>
    </div>
    @if(referenceDocuments.length > 0) {
    <app-attachment-group [attachments]="referenceDocumentsAsChatAttachments" [canRemove]="true"
        [getAttachmentSourceFn]="refDocSourceFn" (removeAttachment)="onRemoveReferenceAttachment($event)"
        [chips]="generateDocAttachmentChips" [maxVisibleAttachments]="20">
    </app-attachment-group>
    } @else {
    <div class="flex flex-col items-center justify-center py-12 gap-2  text-gray-500 h-full">
        <img [src]="'images/bob_agent/top-point-bob.svg' | assetUrl" class="w-[38%] " />
        <span class="text-sm">Click on the upload button to add documents </span>
    </div>
    }
</ng-template>

<ng-template #integrationsConnectorsTemplate>
    <app-menu #connectorsMenu [items]="integrationsConnectorsMenuItems" [class]="'!max-h-[40vh] overflow-y-auto'"
        (itemSelected)="onIntegrationsConnectorSelect($event, connectorsMenu)" [pTooltip]="'Connectors'" tooltipPosition="top">
        <app-button [fullWidth]="true" [icon]="'blocks'" [iconSource]="'lucide'" [iconSize]="'default'"
            variant="outlined" severity="contrast" label="Connectors" (clicked)="connectorsMenu.toggle($event)" />
    </app-menu>
</ng-template>

<ng-template #fileSelectionEmptyState let-tab="tab" let-emptyMessage="emptyMessage"
    let-selectedDropdown="selectedDropdown">
    @if(tab?.id === 'INTEGRATIONS') {
    @if(getIntegrationConnectorConnected(selectedDropdown)) {
    <div class="flex flex-col items-center justify-center h-full text-gray-500">
        <img [src]="'images/bob_agent/404-bob.svg' | assetUrl" class="w-[80%]" />
        <p>{{ emptyMessage }}</p>
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center h-full text-gray-500 px-4">
        <img [src]="'images/integrations-no-connection.svg' | assetUrl" class="w-[80%] max-w-xs" />

        <p class="text-sm mt-1 text-center">Connect your apps to start importing files</p>
    </div>
    }
    } @else {
    <div class="flex flex-col items-center justify-center h-full text-gray-500">
        <img [src]="'images/bob_agent/404-bob.svg' | assetUrl" class="w-[80%]" />
        <p>{{ emptyMessage }}</p>
    </div>
    }
</ng-template>

@if(uploadDocumentsDialogVisible) {
<app-file-selection [visible]="uploadDocumentsDialogVisible" (visibleChange)="uploadDocumentsDialogVisible = $event"
    [config]="fileSelectionConfig" [fetch]="fileSelectionFetch" [dropdownOptions]="fileSelectionDropdownOptions"
    [afterDropdownTemplate]="integrationsConnectorsTemplate" [afterDropdownTemplateTabId]="'INTEGRATIONS'"
    [emptyStateTemplate]="fileSelectionEmptyState" (onSubmit)="onFileSelectionSubmit($event)"
    (onCancel)="onFileSelectionCancel()">
</app-file-selection>
}




<app-dialog [(visible)]="showViewTemplateDialog" class="w-full max-w-4xl h-[85vh]" [fullscreenOnMobile]="true"
    (closed)="showViewTemplateDialog = false">
    <ng-template #headerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="text-sm sm:text-base font-bold truncate">{{ selectedTemplate?.name ?? 'Untitled'}}</div>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="h-full w-full">
            @if(selectedTemplate) {
            <app-document-preview [documentId]="selectedTemplateId ?? ''" [file]="selectedTemplateAttachment" />
            }
        </div>
    </ng-template>
</app-dialog>




<app-dialog [(visible)]="openClausePreviewDialog" class="w-full max-w-4xl h-full"
    (closed)="openClausePreviewDialog = false">
    <ng-template #headerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="text-sm sm:text-base font-bold truncate">{{ selectedClause?.name ?? 'Untitled'}}</div>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="h-full w-full">
            @if(selectedClause) {
            <div class="flex flex-col gap-2 py-4">
                <!-- <span class="text-sm font-semibold">Clause text</span> -->
                {{ selectedClause.text }}
            </div>
            }
        </div>
    </ng-template>
</app-dialog>